module.exports = __webpack_public_path__ + "static/media/news_app.9ef909ce.png";